// extracted by mini-css-extract-plugin
module.exports = {"quicklinks":"QuickLinks_quicklinks__28KcU","link":"QuickLinks_link__aPmTh"};